import { sendPostRequest } from "services/apiService";

const cancelUserSubscription = (
  data: Record<string, unknown>,
): Promise<IGenericAPIResponse & { message?: string }> =>
  sendPostRequest("/chargebee/cancel-subscription", data);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const reactivateUserSubscription = (data: any) =>
  sendPostRequest<
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    any,
    { isSuccess: true } | { isSuccess: false; message: string }
  >("/chargebee/reactivate-subscription", data);

export default {
  cancelUserSubscription,
  reactivateUserSubscription,
};
